<template>
  <auth-template>
    <b-col md="12" sm="8">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <b-form v-on:submit.prevent="onSubmit">
            <h1>Cadastro de Usuário</h1>
            <p class="text-muted">Preencha o formulário a seguir, e cadastre-se!</p>
            <b-alert v-if="alerta_pre_cadastro" show variant="warning">{{mensagem_pre_cadastro}}</b-alert>
            <b-row>
              <b-col cols="6">
                <b-form-group label="CPF:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-mask="'###.###.###-##'"
                                  type="text"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="$v.form.cpf.$model"
                                  :state="chkState('cpf')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback1">CPF é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Data de Nascimento:">
                  <b-input-group>
                    <div class="input-group-prepend">
                             <span class="input-group-text">
                               <i class='fa fa-calendar'></i>
                             </span>
                    </div>
                    <b-form-input id="type-date"
                                  type="date"
                                  v-model="dataNascimento"
                                  v-model.lazy.trim="$v.form.date.$model"
                                  :max="this.maxbirthday" onkeydown="return false"
                                  :state="chkState('date')"></b-form-input>
                    <b-form-invalid-feedback id="input1LiveFeedback2">Data de Nascimento é obrigatória.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nome:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model.trim="$v.form.nome.$model"
                                  :state="chkState('nome')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <b-form-group label="DDD + Telefone Celular">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  v-mask="'+55 (##) #####-####'"
                                  class="form-control"
                                  placeholder="Telefone"
                                  autocomplete="telefone"
                                  v-model.lazy.trim="$v.form.telefone.$model"
                                  :state="chkState('telefone')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback4">Telefone é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="DDD + Telefone Fixo">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  v-mask="'+55 (##) ####-####'"
                                  class="form-control"
                                  placeholder="Telefone"
                                  autocomplete="telefone"
                                  v-model.lazy.trim="$v.form.telefoneFixo.$model"
                                  :state="chkState('telefoneFixo')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback4">Telefone fixo é inválido.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="UF:">
                  <b-form-select v-model.lazy.trim="$v.form.uf.$model" placeholder="Password" :options="estados"
                                 class="mb-3" :state="chkState('uf')">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback5">UF é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Município:"
                              :disabled="disabled_cidades">
                  <b-form-select placeholder="Password"
                                 :options="cidades"
                                 class="mb-3"
                                 v-model.lazy.trim="$v.form.municipio.$model"
                                 :state="chkState('municipio')">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback6">Município é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="E-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  v-model.trim="$v.form.email.$model"
                                  :state="chkState('email')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Confirme o e-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  id="confirmar-email"
                                  placeholder="Confirme o e-mail"
                                  oncut="return false"
                                  onpaste="return false"
                                  autocomplete="confirme-email"
                                  v-model.trim="$v.form.confirmaEmail.$model"
                                  :state="chkState('confirmaEmail')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback8">Este é um campo obrigatório, e deve ser correspondente ao campo e-mail.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Tipo de Usuário:">
                  <b-form-select v-model.trim="$v.form.tipoUsuario.$model" :state="chkState('tipoUsuario')"
                                 placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório, e deve ser um endereço
                    de e-mail válido.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="$v.form.tipoUsuario.$model > 2">
              <b-col cols="1">
                <div class="custom-control custom-checkbox">
                  <b-form-checkbox
                    v-model="valueAceiteTipoUsuario"
                    :options="options"
                    :state="valueAceiteTipoUsuario"
                    name="checkbox-validation"
                    class="teste">
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col cols="11">
                <p>Declaro, para os devidos fins, que concordo com o armazenamento dos meus dados pessoais para a participação no Projeto Mães Unidas. Ao concordar, eu autorizo que o Ministério da Mulher, da Família e dos Direitos Humanos tenha acesso a eles, para fins estatísticos e para aprimoramento do Projeto.</p>
              </b-col>
              <b-col cols="12"></b-col>
              <b-col cols="5"><br>
                <b-form-invalid-feedback :state="valueAceiteTipoUsuario">A aceitação é obrigatória para esse tipo de usuário.
                </b-form-invalid-feedback>
                <br>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Senha:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Senha"
                                  v-model.trim="$v.form.senha.$model" :state="chkState('senha')"
                                  autocomplete="new-password"/>
                    <b-form-invalid-feedback id="input1LiveFeedback10">Este é um campo obrigatório, e precisa ter no
                      mínimo 6 dígitos.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Confirmar a Senha:">
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Confirmar a Senha"
                                  v-model.trim="$v.form.confirmaSenha.$model" :state="chkState('confirmaSenha')"
                                  autocomplete="new-password"/>
                    <b-form-invalid-feedback id="input1LiveFeedback11">Este é um campo obrigatório, e as senhas devem
                      corresponder.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" :disabled="true">
                <b-form-textarea readonly id="textarea" v-model="text" rows="3" max-rows="6"></b-form-textarea>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="11">
                <br>
                <b-form-checkbox
                  v-model="valueAceiteCadastro"
                  :options="options2"
                  :state="valueAceiteCadastro"
                  name="checkbox-validation">Confirmo a leitura e o aceite do termo de uso
                </b-form-checkbox>
                <b-form-invalid-feedback :state="valueAceiteCadastro">A aceitação é obrigatória para completar o seu cadastro.
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col md="3" offset-md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Criar Usuário</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/login')">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar para o Login</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-col>
  </auth-template>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength, email, sameAs} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const formShape = {
  cpf: '',
  date: '',
  nome: '',
  telefone: '',
  telefoneFixo: '',
  uf: null,
  municipio: null,
  tipoUsuario: 2,
  email: '',
  senha: '',
  confirmaSenha: '',
  confirmaEmail: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      cpf: {
        required,
        minLength: minLength(14)
      },
      date: {
        required,
        maxLength: maxLength(15)
      },
      nome: {
        required
      },
      telefone: {
        required,
        minLength: minLength(19)
      },
      telefoneFixo: {
        minLength: minLength(18)
      },
      uf: {
        required
      },
      municipio: {
        required
      },
      email: {
        required,
        email
      },
      confirmaEmail: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      tipoUsuario: {
        required
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      confirmaSenha: {
        required,
        sameAsSenha: sameAs('senha')
      }
    }
  },
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarTipoUsuarios')
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      text: 'Declaro, para os devidos fins, que concordo com o armazenamento dos meus dados pessoais para a participação no Projeto Mães Unidas. Ao concordar, eu autorizo que o Ministério da Mulher, da Família e dos Direitos Humanos tenha acesso a eles, para fins estatísticos e para aprimoramento do Projeto.',
      status_aceite: 'not_accepted',
      disabled_cidades: true,
      disable_buttons: false,
      valueAceiteTipoUsuario: false,
      valueAceiteCadastro: false,
      titulo_toast: 'Alerta!',
      options: [
        {value: true}
      ],
      options2: [
        {value: true}
      ],
      alerta_pre_cadastro: false,
      mensagem_pre_cadastro: ''
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  watch: {
    '$v.form.uf.$model': function () {
      if (this.$v.form.uf.$model !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.$v.form.uf.$model)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
      }
    }
  },
  methods: {
    salvar () {
      let form = this.$v.form
      let data = {
        cpf: form.cpf.$model.replace(/[^\d]+/g, ''),
        data_nascimento: form.date.$model,
        nome: form.nome.$model,
        telefone: form.telefone.$model.replace(/[^\d]+/g, ''),
        telefone_fixo: form.telefoneFixo.$model.replace(/[^\d]+/g, ''),
        estado_id: parseInt(form.uf.$model),
        cidade_id: parseInt(form.municipio.$model),
        email: form.email.$model,
        email_confirmation: form.confirmaEmail.$model,
        password: form.senha.$model,
        password_confirmation: form.confirmaSenha.$model,
        ativo: true,
        perfis: JSON.stringify([{ id: form.tipoUsuario.$model }]),
        gerarToken: true,
        situacao: true
      }

      if (form.tipoUsuario.$model > 2) {
        data.situacao = false
        data.perfis = JSON.stringify([{ id: 2 }])
        data.perfil_temporario = form.tipoUsuario.$model
      }

      Vue.http.post('api/usuario/store/pub', data).then(response => {
        if (response.body.success) {
          SessionStorage.set('usuario', JSON.stringify(response.body.data[0].id))
          SessionStorage.set('token', response.body.data[0].token)
          SessionStorage.setObject('permissoes', response.body.data[1][0][0].permissoes)
          this.$store.commit('setUsuario', response.body.data[0])
          if (form.tipoUsuario.$model > 2) {
            this.alerta_pre_cadastro = true
            this.mensagem_pre_cadastro = 'Caro Usuário, seu cadastro foi encaminhado para ativação. Você já possui a permissão básica para navegação pelos serviços. Caso sua solicitação seja aprovada o seu nível de permissão será ajustado automaticamente'
            window.scrollTo({ top: 0, behavior: 'smooth' })
            setTimeout(() => this.$router.push({path: '/'}), 10000)
          } else {
            miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            this.$router.push({path: '/'})
          }
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.validate() && this.validateTermos()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    validateTermos () {
      let bool = true
      if (!this.valueAceiteCadastro) {
        bool = false
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Aceite os termos para criação de sua conta.', this.titulo_toast, 5000)
      }

      if (this.$v.form.tipoUsuario.$model > 2) {
        if (!this.valueAceiteTipoUsuario) {
          bool = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error('Aceite os termos para o tipo de usuário.', this.titulo_toast, 5000)
        }
      }
      return bool
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/Cadastro.vue